import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { SanitizeCharsDirective } from '../../../directives/sanitize-chars.directive';
import { AlphanumericCellEditorBaseComponent } from '../alphanumeric-cell-editor-base/alphanumeric-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-alphanumeric-cell-editor-popup',
    templateUrl: './alphanumeric-cell-editor-popup.component.html',
    styleUrls: ['./alphanumeric-cell-editor-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FocusSelectOnDirective,
        SanitizeCharsDirective,
        TranslateModule,
    ],
})
export class AlphanumericCellEditorPopupComponent extends AlphanumericCellEditorBaseComponent {
    /**
     * specify the space available for the popup editor
     * passed by NumericCellEditorComponent as cellWidth
     */
    readonly width = input.required<string>();
}
